import styles from './home-authed.module.scss';

export type DashboardIconName =
  | 'arrow'
  | 'check'
  | 'map'
  | 'profile'
  | 'wallet';

type DashboardIconProps = {
  name: DashboardIconName;
};

const iconPaths: Record<DashboardIconName, JSX.Element> = {
  arrow: <path d="m9 5 7 7-7 7M4 12h12" />,
  check: <path d="m5 12 4 4L19 7" />,
  map: (
    <>
      <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
  profile: (
    <>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 21a7 7 0 0 1 14 0" />
    </>
  ),
  wallet: (
    <>
      <path d="M4 7.5h15a2 2 0 0 1 2 2V19H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12" />
      <path d="M16 12h5v4h-5a2 2 0 0 1 0-4Z" />
    </>
  ),
};

const DashboardIcon: React.FC<DashboardIconProps> = ({ name }) => (
  <svg
    aria-hidden="true"
    className={styles.icon}
    fill="none"
    viewBox="0 0 24 24"
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    >
      {iconPaths[name]}
    </g>
  </svg>
);

export default DashboardIcon;
